import { getStorageItem, setStorageItem } from 'CorePackage/MainModule/common/localStore';
import { StorageNamesEnum } from 'CorePackage/MainModule/enums/StorageNamesEnum';
import { IErknmAnalyticsTableColumn } from 'AnalyticsPackage/ErknmAnalyticsModule/interfaces/IErknmAnalyticsTableColumn';
import { IErknmAnalyticsState } from 'AnalyticsPackage/ErknmAnalyticsModule/interfaces/IErknmAnalyticsState';

import { initialErknmAnalyticsProsecutorOrganizationTableColumns } from '../contstants/initialErknmAnalyticsProsecutorOrganizationTableColumns';
import { ErknmAnalyticsProsecutorOrganizationActionsEnum } from '../enums/ErknmAnalyticsProsecutorOrganizationActionsEnum';
import { ErknmAnalyticsProsecutorOrganizationAction } from '../types/ErknmAnalyticsProsecutorOrganizationAction';

const columnsRaw = getStorageItem<IErknmAnalyticsTableColumn[]>(StorageNamesEnum.ERKNM_ANALYTICS_COLUMNS);
const initialColumns: IErknmAnalyticsTableColumn[] =
  columnsRaw || initialErknmAnalyticsProsecutorOrganizationTableColumns;

const initialState: IErknmAnalyticsState = {
  data: [],
  page: 0,
  hasMoreData: true,
  localDateTime: null,
  tableColumns: initialColumns,
  knmList: [],
  knmPage: 0,
  knmPageCount: 0,
  knmTotalCount: 0,
  knmOrder: null,
};

export function erknmAnalyticsProsecutorOrganizationReducer(
  state: IErknmAnalyticsState = initialState,
  action: ErknmAnalyticsProsecutorOrganizationAction,
) {
  switch (action.type) {
    case ErknmAnalyticsProsecutorOrganizationActionsEnum.SET_DATA: {
      const newState: IErknmAnalyticsState = {
        ...state,
        data: action.payload.data,
        page: action.payload.page,
        hasMoreData: action.payload.hasMoreData,
        localDateTime: action.payload.localDateTime,
      };

      return newState;
    }
    case ErknmAnalyticsProsecutorOrganizationActionsEnum.SET_FILTER: {
      const newState: IErknmAnalyticsState = {
        ...state,
        filter: action.payload.filter,
      };

      return newState;
    }
    case ErknmAnalyticsProsecutorOrganizationActionsEnum.SET_TABLE_COLUMNS: {
      const newState: IErknmAnalyticsState = {
        ...state,
        tableColumns: [...initialErknmAnalyticsProsecutorOrganizationTableColumns, ...action.payload.columns],
      };

      setStorageItem(StorageNamesEnum.ERKNM_ANALYTICS_COLUMNS, newState.tableColumns);

      return newState;
    }
    case ErknmAnalyticsProsecutorOrganizationActionsEnum.SET_KNM_LIST: {
      const { data: knmList, page: knmPage, pageCount: knmPageCount, totalCount: knmTotalCount } = action.payload;
      const newState: IErknmAnalyticsState = {
        ...state,
        knmList,
        knmPage,
        knmTotalCount,
        knmPageCount,
      };

      return newState;
    }
    case ErknmAnalyticsProsecutorOrganizationActionsEnum.SET_ORDER: {
      const newState: IErknmAnalyticsState = {
        ...state,
        knmOrder: action.payload.order,
      };

      return newState;
    }
    default:
      return state;
  }
}
